import type { NavigateToOptions } from 'nuxt/dist/app/composables/router'

export const useCommon = () => {
  const navigate = (url: string, partnersKey?: string, options?: NavigateToOptions) => {
    if (!partnersKey || typeof partnersKey === 'undefined' || partnersKey === 'undefined') {
      navigateTo(url, options)
    } else {
      navigateTo(`/partners/${partnersKey}${url}`, options)
    }
  }

  const routeBack = (partnersKey?:string) => {
    const router = useRouter()
    switch (router.options.history.state.back) {
      case null :
        navigate('/', partnersKey)
        break
      default :
        router.back()
        break
    }
  }


  return {
    navigate,
    routeBack
  }
}
